import React, { Fragment, useEffect, useContext, useState } from "react";
import { Link, Redirect } from "react-router-dom";
import { observer, useObserver } from "mobx-react-lite";
import Grid from "@material-ui/core/Grid";

/* container */
import { GlobalProvider } from "../../lib-atomic-context";
import CMSContainer from "../../app-module-cms-container/default";
/* container */

/* packages */
import { GlobalContext } from "../../lib-atomic-context";
import {
  ModuleContainerLg,
  ModuleFormWrapper,
  ModuleFormItemWrapper,
  ModulePaddedWrapperLg,
  ModulePaperWrapper,
  ModuleTitle,
  ModuleText,
  ModuleSubTitle,
} from "../../lib-atomic-design-section";
import { Buttons } from "../../lib-atomic";
/* packages */

const index = (props) => {
  const handleBack = () => {
    props.history.push("/corporate/login");
  };
  /* data props */
  const backButton = { size: "medium", onClick: handleBack };

  return (
    <ModuleFormItemWrapper>
      <ModulePaperWrapper>
        <ModuleTitle>Request to reset your Password received.</ModuleTitle>
        <br />
        <ModuleSubTitle>
          If the supplied information matches our records, an email will be sent
          to your account to confirm your password change.
        </ModuleSubTitle>
        <br />
        <ModuleFormWrapper>
          <ModuleFormItemWrapper>
            <Buttons.Normal {...backButton}>BACK</Buttons.Normal>
          </ModuleFormItemWrapper>
        </ModuleFormWrapper>
      </ModulePaperWrapper>
    </ModuleFormItemWrapper>
  );
};

export default index;
